import './sass/style.scss'
import 'velocity-animate'
import 'waypoints/lib/jquery.waypoints.min.js'

//import { wayPoint, velocityDownUp } from './js/general'

(function ($) {

	function wayPoint(elemeway, delay, animationFun) {
		elemeway.waypoint(function () {
			var elem = $(this.element);
			setTimeout(function () {
				animationFun(elem);
			}, delay);
			this.destroy();
		}, {
			offset: '100%'
		});
	}

	function velocityDownUp(elem) {
		elem.velocity({ top: '0px', opacity: 1 }, { duration: 1500, easing: "easeOutQuart", delay: 100 });
	}

	function parallaxImages(elem) {
		if (elem.length != 0) {
			var parent = elem.parent(),
				speed = elem.data('speed'),
				parentY = parent.offset().top,
				parentTop = parent[0].getBoundingClientRect().top,
				winY = $(window).scrollTop(),
				winH = $(window).height(),
				parentH = parent.innerHeight(),
				winBottom = winY + winH;

			if ((winBottom > parentY) && (winY < parentY + parentH)) {
				var offSetPosition = winH - parentTop,
					translationPercent = (offSetPosition - winH) * speed;
			}
			elem.css({ transform: 'translate3d(0, ' + translationPercent + 'px, 0)' });
		}

	}

	function giveClassInView(elem, theClass, internalClass) {
		if (elem.length != 0) {
			var parent = elem.parent(),
				parentH = parent.innerHeight(),
				parentTop = parent[0].getBoundingClientRect().top,
				winY = $(window).scrollTop(),
				winH = $(window).height(),
				offSetTop = winY + parentTop,
				offSetPosition = winH + winY - offSetTop;

			if (offSetPosition > 0 && offSetPosition < (parentH + winH)) {
				if (elem.find(internalClass).length) {
					elem.find(internalClass).addClass(theClass);
				} else {
					elem.addClass(theClass);
				}
			} else {
				if (elem.find(internalClass).length) {
					elem.find(internalClass).removeClass(theClass);
				} else {
					elem.removeClass(theClass);
				}
			}
		}
	}

	function readyElement() {
		setTimeout(function () {
			$('.background-box .background-wrapper').addClass('ready-to-show');
			giveClassInView($('.background-box .background-wrapper'), 'background-zoomout', '.background-main');
		}, 1000);
	}

	$(document).ready(function () {
		readyElement();
		wayPoint($("#main-posts-wrapper .post-main"), 10, velocityDownUp);
	});//ready


	$(window).on('load', function () {

		//$('.preloader').delay(0).fadeOut(100);
	});

	$(window).on('resize', function () {

	});

	$(window).scroll(function () {
		if (window.matchMedia('(max-width: 767px )').matches) {
			$(this).scrollTop() > 100 ? $('#masthead').addClass('sticky-header') : $('#masthead').removeClass('sticky-header');
		} else {
			$(this).scrollTop() > 300 ? $('#masthead').addClass('sticky-header') : $('#masthead').removeClass('sticky-header');
		}

		if ($(this).scrollTop() > 100) {
			$('#gototop').css({ bottom: '30px' });
		} else {
			$('#gototop').css({ bottom: '-100px' });
		}

		parallaxImages($('.background-box .background-wrapper'));
		setTimeout(function () {
			giveClassInView($('.background-box .background-wrapper'), 'background-zoomout', '.background-main');
		}, 200);

	});


	$('#gototop').click(function () {
		$('html, body').animate({ scrollTop: '0px' }, 800);
		return false;
	})//click

	$('a.astra-search-icon').on('click', function (e) {
		e.preventDefault();
		$('#full-screen-search').velocity({ left: '0%', opacity: 1 }, { duration: 1000, easing: "linear" });
		$('input.search-field').focus();

	});

	$('#close-search').on('click', function (e) {
		e.preventDefault();
		$('#full-screen-search').velocity({ left: '-100%', opacity: 0 }, { duration: 1000, easing: "linear" });

	});

	function addLink() {
		var body_element = document.getElementById('content'),
			selection = window.getSelection(),
			pagelink = "Nos halaga que te guste nuestro contenido. Comp\u00e1rtelo usando nuestros botones de redes sociales. Lee \u00E9sta nota: <a href='" + document.location.href + "'>" + document.location.href + "</a><br /> en israeladentro.com",
			copytext = pagelink,
			newdiv = document.createElement('div');
		newdiv.style.position = 'absolute';
		newdiv.style.left = '-99999px';
		body_element.appendChild(newdiv);
		newdiv.innerHTML = copytext;
		selection.selectAllChildren(newdiv);
		window.setTimeout(function () {
			body_element.removeChild(newdiv);
		}, 0);
	}
	document.oncopy = addLink;

})(jQuery);